import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Send, Loader2, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { UserNotifyStatus } from "@/components/UserNotifyStatus";
import { TestButton } from "@/components/NotifyTestButton";
import { NOTIFY } from "@/constants/testIds";

export default function NotifySettingsAdmin() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/notify-settings").then(({ data: d }) => setData(d)).catch((e) => toast.error(errMsg(e)));
  }, []);

  if (!data) return <Loader2 className="h-5 w-5 animate-spin text-brand" />;

  return (
    <div className="max-w-4xl space-y-6">
      <div className="fade-up">
        <p className="overline-label">Pengaturan · Super Admin</p>
        <h1 className="font-heading mt-2 text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900">Pengaturan Notifikasi</h1>
        <p className="mt-2 text-sm leading-relaxed text-slate-500">
          Pengingat booking dicek tiap 15 menit dan dikirim satu kali saat masuk H-2 pelunasan / H-3 guest data.
          <b> WhatsApp</b> hanya dikirim ke nomor CS yang membuat booking. <b>Email</b> dikirim ke pembuat booking dan semua Admin/Super Admin. <b>Telegram</b> dikirim ke grup staf.
        </p>
      </div>
      <section className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-slate-200 bg-white p-5" data-testid={NOTIFY.telegramStatus}>
        <p className="flex items-center gap-2 text-sm text-slate-700"><Send className="h-4 w-4 shrink-0 text-brand" />
          {data.telegram_configured ? "Bot Telegram sudah diatur. Klik Tes Telegram untuk memastikan pesan masuk ke grup." : "Bot Telegram belum dikonfigurasi."}</p>
        <TestButton channel="telegram" disabled={!data.telegram_configured} />
      </section>
      <section className="rounded-lg border border-slate-200 bg-white p-5" data-testid={NOTIFY.whatsappStatus}>
        <p className="flex items-center gap-2 text-sm text-slate-700"><MessageCircle className="h-4 w-4 shrink-0 text-brand" />
          {data.whatsapp_configured ? "WhatsApp (Fonnte) sudah diatur. Pengingat dikirim dari nomor kantor yang terhubung di Fonnte." : "WhatsApp (Fonnte) belum dikonfigurasi."}</p>
        <p className="mt-2 text-xs text-slate-500">Paket gratis Fonnte: 1.000 pesan/bulan. Jaga perangkat tetap terhubung (scan QR) di dashboard Fonnte.</p>
      </section>
      <section className="rounded-lg border border-slate-200 bg-white p-5 text-xs leading-relaxed text-slate-600">
        <p className="mb-2 flex items-center gap-2 text-sm font-medium text-slate-900"><MessageCircle className="h-4 w-4 shrink-0 text-brand" />Email & WhatsApp tiap staf</p>
        <p>Isi atau ubah email dan nomor WhatsApp di menu <Link to="/pengguna" className="font-medium text-brand hover:underline" data-testid={NOTIFY.usersLink}>Kelola Pengguna</Link> (ikon pensil pada akun). Gunakan tombol tes di bawah untuk memastikan pesan sampai.</p>
      </section>
      <ul className="divide-y divide-slate-200 rounded-lg border border-slate-200 bg-white">
        {data.users.map((u) => <UserNotifyStatus key={u.id} u={u} waOn={data.whatsapp_configured} />)}
      </ul>
    </div>
  );
}
